import { Loading } from "@mnk/frontend/components/Loading";
import { PrimaryButton } from "@mnk/frontend/components/ui/button/PrimaryButton";
import { Success } from "@mnk/frontend/components/ui/flashMessage/Success";
import { trpc } from "@mnk/frontend/lib/trpc";
import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";

export const AccountForm = () => {
  const [name, setName] = useState("");
  const [processing, setProcessing] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const getUser = trpc.getUser.useQuery();
  const user = getUser.data;

  useEffect(() => {
    setName(user?.name ?? "");
  }, [user]);

  const editUserMutation = trpc.editUserName.useMutation();
  const editUser = async () => {
    try {
      setProcessing(true);
      await editUserMutation.mutateAsync({ name });
      getUser.refetch();
      setShowSuccessMessage(true);
    } catch (error) {
      console.error(error);
    } finally {
      setProcessing(false);
    }
  };

  const canSubmit = useMemo(() => name.length > 0 && name !== user?.name && !processing, [name, user, processing]);

  if (getUser.isLoading) return <Loading />;

  return (
    <div className="w-full bg-white rounded-lg">
      <div className="flex items-center justify-between p-4 border-b border-gray-200">
        <p className="text-xl font-bold">アカウント設定</p>
      </div>
      <div className="flex flex-col gap-8 px-4 py-8">
        <div className="flex flex-col gap-2">
          <p className="text-sm font-bold">メールアドレス （変更不可）</p>
          <input
            type="text"
            className="w-full p-2 border border-gray-200 bg-gray-100 rounded-md"
            value={user?.email}
            disabled
          />
        </div>

        <div className="flex flex-col gap-2">
          <p className="text-sm font-bold">事業所名 （変更不可）</p>
          <input
            type="text"
            className="w-full p-2 border border-gray-200 bg-gray-100 rounded-md"
            value={user?.officeName}
            disabled
          />
        </div>

        <div className="flex flex-col gap-2">
          <p className="text-sm font-bold">名前</p>
          <input
            type="text"
            className="w-full p-2 border border-gray-200 rounded-md"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        <PrimaryButton className="w-full" onClick={editUser} disabled={!canSubmit}>
          変更
        </PrimaryButton>

        <div className="flex flex-col gap-2">
          <p className="text-sm font-bold">パスワード</p>
          <p className="text-sm text-gray-500">
            パスワードの変更は
            <Link className="text-blue-500 underline" to="/settings/password-reset" type="button">
              こちら
            </Link>
          </p>
        </div>
      </div>
      {showSuccessMessage && <Success message="名前を変更しました" onClose={() => setShowSuccessMessage(false)} />}
    </div>
  );
};
